import { removeStylesFromEditorV3 } from "@azu-business/editor-v3";
import { AioExternalReplacements } from "aic";
import { STYLES_TO_CLEAN, STYLES_TO_DELETE } from "../../../config";
import { removeStylesFromSubLists } from "./removeStylesFromSubLists";

/**
 * Removes Optional and Notes styles from external replacement lists (hierarchy context).
 * Processes nested subLists recursively. This function is specific to hierarchy-level
 * external replacements (`AioExternalReplacements`) and does not handle merging or
 * externalName management (used in TLF table contexts).
 *
 * @param lists - Array of external replacement lists with EditorV3 content from hierarchy
 * @returns New array of external replacement lists with styles removed from all texts
 */
export const removeStylesFromExternalLists = <T>(
  lists: AioExternalReplacements<T>[],
): AioExternalReplacements<T>[] => {
  return lists.map((list) => ({
    ...list,
    newTexts: list.newTexts.map((newText) => ({
      ...newText,
      texts: newText.texts.map((text) =>
        removeStylesFromEditorV3(text, STYLES_TO_DELETE, STYLES_TO_CLEAN),
      ),
      subLists: removeStylesFromSubLists(newText.subLists),
    })),
  }));
};
